<template>
    <div class="credit-info">
        <b-card no-body>
            <b-card-header class="py-2 px-3">
                <h4 class="mb-0">Credit Info at a Glance</h4>
            </b-card-header>
            <b-table-simple responsive table-variant="white">
                <b-thead head-variant="light">
                    <b-tr>
                        <b-th>Credit Info/<br>Source</b-th>
                        <b-th class="text-right">#</b-th>
                        <b-th class="text-right">Value</b-th>
                    </b-tr>
                </b-thead>
                <b-tbody>
                    <b-tr>
                        <b-th scope="row">
                            <p class="font-weight-500 text-break">Bankruptcy</p>
                            <p class="font-weight-500 text-break">Proceedings Record</p>
                            <p class="text-xs font-weight-400">{{ tableData.credit_info_bankruptcy_source }}</p>
                        </b-th>
                        <b-td class="text-right">-</b-td>
                        <b-td class="text-right">{{ tableData.credit_info_bankruptcy == 1 ? 'Yes' : 'No' }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">
                            <p class="font-weight-500 text-break">Legal records in</p>
                            <p class="font-weight-500 text-break">past 24 months</p>
                            <p class="font-weight-500 text-break">(personal capacity)</p>
                            <p class="text-xs font-weight-400">{{ tableData.credit_info_legal_personal_capacity_source }}</p>
                        </b-th>
                        <b-td class="text-right">{{ tableData.credit_info_legal_personal_capacity_total }}</b-td>
                        <b-td class="text-right">{{ tableData.credit_info_legal_personal_capacity_value | moneyFormatter  }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">
                            <p class="font-weight-500 text-break">Legal records in</p>
                            <p class="font-weight-500 text-break">past 24 months</p>
                            <p class="font-weight-500 text-break">(Non-personal</p>
                            <p class="font-weight-500 text-break">capacity)</p>
                            <p class="text-xs font-weight-400">{{ tableData.credit_info_legal_non_personal_capacity_source }}</p>
                        </b-th>
                        <b-td class="text-right">{{ tableData.credit_info_legal_non_personal_capacity_total }}</b-td>
                        <b-td class="text-right">{{ tableData.credit_info_legal_non_personal_capacity_value | moneyFormatter  }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">
                            <p class="font-weight-500 text-break">Availability of Legal</p>
                            <p class="font-weight-500 text-break">Records</p>
                            <p class="text-xs font-weight-400">{{ tableData.credit_info_legal_source }}</p>
                        </b-th>
                        <b-td class="text-right">-</b-td>
                        <b-td class="text-right">{{ tableData.credit_info_legal_total >= 1 ? 'Yes' : 'No' }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">
                            <p class="font-weight-500 text-break">Special Attention</p>
                            <p class="font-weight-500 text-break">Accounts</p>
                            <p class="text-xs font-weight-400">{{ tableData.credit_info_ccris_special_attention_source }}</p>
                        </b-th>
                        <b-td class="text-right">-</b-td>
                        <b-td class="text-right">{{ tableData.credit_info_ccris_special_attention == 1 ? 'Yes' : 'No' }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">
                            <p class="font-weight-500 text-break">Availability of</p>
                            <p class="font-weight-500 text-break">Dishonoured</p>
                            <p class="font-weight-500 text-break">Cheques</p>
                        </b-th>
                        <b-td class="text-right">-</b-td>
                        <b-td class="text-right">{{ tableData.credit_info_dcheqs == 1 ? 'Yes' : 'No' }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">
                            <p class="font-weight-500 text-break">Outstanding Credit</p>
                            <p class="font-weight-500 text-break">Facilities</p>
                            <p class="text-xs font-weight-400">{{ tableData.credit_info_ccris_facility_source }}</p>
                            <p class="font-italic text-xs font-weight-400" v-if="tableData.credit_info_ccris_facility_arrears  == 0">
                                *No installments in<br> arrears in<br> past 15 months
                            </p>
                            <p class="font-italic text-xs font-weight-400" v-else>
                                *Have installments in<br> arrears in<br> past 15 months
                            </p>
                        </b-th>
                        <b-td class="text-right">{{ tableData.credit_info_ccris_facility_total }}</b-td>
                        <b-td class="text-right">{{ tableData.credit_info_ccris_facility_value | moneyFormatter }}</b-td>
                    </b-tr>
                    <b-tr>
                        <b-th scope="row">
                            <p class="font-weight-500 text-break">Credit Applications</p>
                            <p class="font-weight-500 text-break">in past 15 months</p>
                            <p class="text-xs font-weight-400">{{ tableData.credit_info_ccris_application_source }}</p>
                            <p class="font-italic text-xs font-weight-400" v-if="tableData.credit_info_ccris_aplication_total == 0 && tableData.credit_info_ccris_application_approved == 0 && tableData.credit_info_ccris_application_pending == 0">
                                *No total, approved &amp; pending
                            </p>
                            <p class="font-italic text-xs font-weight-400" v-else>
                                Total - {{ tableData.credit_info_ccris_aplication_total }}<br>
                                Approved - {{ tableData.credit_info_ccris_application_approved }}<br>
                                Pending - {{ tableData.credit_info_ccris_application_pending }}<br>
                            </p>
                        </b-th>
                        <b-td class="text-right">-</b-td>
                        <b-td class="text-right">-</b-td>
                    </b-tr>
                </b-tbody>
            </b-table-simple>
        </b-card>
    </div>
</template>
<script>
    import { Card, Button } from 'element-ui'

    export default {
        name: 'credit-info',
        props: ['credit-info'],
        components: {
            [Card.name]: Card,
            [Button.name]: Button,
        },
        data() {
            return {
                tableData: this.creditInfo
            }
        }
    }
</script>